module.exports = __webpack_public_path__ + "img/face-img.338202b7.png";